import { render, staticRenderFns } from "./StripeQuotaPayment.vue?vue&type=template&id=0943981a&scoped=true&"
import script from "./StripeQuotaPayment.vue?vue&type=script&lang=js&"
export * from "./StripeQuotaPayment.vue?vue&type=script&lang=js&"
import style0 from "./StripeQuotaPayment.vue?vue&type=style&index=0&id=0943981a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0943981a",
  null
  
)

/* custom blocks */
import block0 from "./StripeQuotaPayment.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./StripeQuotaPayment.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAlert,VBtn,VCheckbox})
